/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import LegalDocumentForm from './LegalDocumentForm.vue';
import LegalDocumentFormWithTemplate from './LegalDocumentFormWithTemplate.vue';

const __vue_script__ = {
    name: 'LegalDocumentsEditor',

    components: { LegalDocumentForm, LegalDocumentFormWithTemplate, Checkbox },

    props: {
        docId: {
            type: String,
            default: '',
        },

        orgId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            title: '',
            doc: {},
            useTemplates: false,
            templates: [],
            disableSave: true,
            updatedDoc: {},
        };
    },

    async mounted() {
        this.templates = await this.$services.legal.getAllDocumentTemplates();
        if (this.docId === '') {
            this.title = this.$i18n.t('legal_documents.editor.create_new');
            return;
        }
        this.title = this.$i18n.t('legal_documents.editor.edit');
        this.doc = await this.$services.legal.getLegalDocument(this.docId);
        if (this.doc.template) { this.useTemplates = true; }
    },

    methods: {
        onDocChange(doc) {
            this.updatedDoc = doc;

            const isTemplateAndHasNotAcknowledgedDisclamer = doc.template && !doc.use_ackd;
            const isTemplateAndTitleIsEmpty = doc.template && doc.template_title === '';
            const isNotTemplateAndHasEmptyTitleInSomeLanguage = !doc.template && Object.keys(doc.title || {}).some(key => doc.title[key] === '');

            this.disableSave = isTemplateAndHasNotAcknowledgedDisclamer
                || isTemplateAndTitleIsEmpty
                || isNotTemplateAndHasEmptyTitleInSomeLanguage;
        },

        createNewDoc(doc) {
            return this.$services.legal.createLegalDocumentForOrg(this.orgId, doc);
        },

        updateDoc(doc) {
            return this.$services.legal.updateLegalDocument(this.docId, doc);
        },

        async onSubmit() {
            const request = this.docId === ''
                ? this.createNewDoc
                : this.updateDoc;

            try {
                await request(this.updatedDoc);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('legal_documents.editor.doc_saved').toString(),
                    type: 'success',
                });

                this.$emit('close');
            } catch (error) {
                console.error('[LegalDocumentsEditor] Could not save changes:', error);
                this.$notify({
                    group: 'flashes',
                    text: error.message,
                    type: 'error'
                });
            }
        },

        toggleTemplate() {
            this.useTemplates = !this.useTemplates;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-wrapper" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c("span", {
        staticClass: "close",
        on: {
          click: function () {
            return _vm.$emit("close")
          },
        },
      }),
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
    ]),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        !_vm.useTemplates
          ? _c("legal-document-form", {
              attrs: { orgId: _vm.orgId, "legal-doc": _vm.doc },
              on: { change: _vm.onDocChange },
            })
          : _c("legal-document-form-with-template", {
              attrs: { "legal-doc": _vm.doc, templates: _vm.templates },
              on: { change: _vm.onDocChange },
            }),
      ],
      1
    ),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" },
        },
        [
          _c(
            "button",
            { staticClass: "btn", on: { click: _vm.toggleTemplate } },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "legal_documents.editor.template_or_not." +
                      (_vm.useTemplates ? "create_doc" : "use_template")
                  )
                )
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: _vm.disableSave },
              on: { click: _vm.onSubmit },
            },
            [_vm._v(_vm._s(_vm.$t("general.save")))]
          ),
        ]
      ),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/organizations/legal-documents/LegalDocumentsEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__